<h1 mat-dialog-title>{{data.id}}</h1>

<div mat-dialog-content>
  <metering-points-consumption-table [meteringPointConsumptionData]="data.consumptionData"></metering-points-consumption-table>
</div>

<div mat-dialog-actions [align]="'end'" class="padded-actions">
  <button mat-flat-button (click)="onNoClick()" id="modalCancel">{{'ModalCloseButton' | translate}}</button>
</div>
